// Verify email card

import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Card from './Card';
import { useFirebase } from './FirebaseContextProvider';
import { authSendEmailVerification } from '../utils/firebase';
import Spinner from './Spinner';
import './VerifyEmailCard.scss';

export default function VerifyEmailCard() {
  const [spinner, setSpinner] = useState(false);
  const { user, refreshEmailVerified } = useFirebase();
  const navigate = useNavigate();

  const handleSendVerification = async () => {
    try {
      setSpinner(true);
      await authSendEmailVerification({
        email: user.email,
        link: `${window.location.origin}/login`,
      });
      toast.success('Verification email sent. Please check your inbox.');
    } catch (e) {
      toast.error('Failed to send verification email. Please try again.');
    } finally {
      setSpinner(false);
    }
  };

  const handleRefreshVerificationStatus = async () => {
    setSpinner(true);
    const verified = await refreshEmailVerified();
    setSpinner(false);

    if (verified) {
      navigate('/login', { replace: true });
    } else
      toast.error(
        'Email not verified yet. Please check your inbox and click the verification link.'
      );
  };

  return (
    <Card header='Email verification required' className='verify-email-card'>
      <p className='font-16'>
        To continue using the app, please verify your email address. We've sent
        you a verification email. Open your inbox and click the link to complete
        the process.
      </p>
      <p className='font-16'>
        If you didn't receive the message, you can request a new one here:{' '}
        <Link onClick={handleSendVerification}>Resend verification email</Link>
      </p>
      <button onClick={handleRefreshVerificationStatus}>
        I've verified — check again
      </button>
      <Spinner show={spinner} />
    </Card>
  );
}
